import { SmallGroup } from '../../../types/smallGroup';
import ApprovalStampBox from '../ApprovalStampBox';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../quality/SmallGroupPanel.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';

interface Props {
  detail: SmallGroup;
}

function SmallGroupPreviewView({ detail }: Props) {
  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <h3 style={{ margin: 0 }}>소집단</h3>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            소집단번호
            <input readOnly value={detail.groupNo || ''} />
          </label>
          <label>
            구성일
            <input type="date" readOnly value={detail.formedDate || ''} />
          </label>
          <label className="is-span-2">
            소집단명 *
            <input readOnly value={detail.groupName || ''} />
          </label>
          <label className="is-span-2">
            개선주제
            <input readOnly value={detail.theme || ''} />
          </label>
          <label>
            상태
            <select value={detail.status || 'ACTIVE'} disabled>
              <option value="ACTIVE">활동중</option>
              <option value="CLOSED">해체</option>
            </select>
          </label>
          <label>
            해체일
            <input type="date" readOnly value={detail.closedDate || ''} />
          </label>
          <label>
            회의주기
            <input readOnly value={detail.meetingCycle || ''} />
          </label>
          <label>
            회의장소
            <input readOnly value={detail.meetingPlace || ''} />
          </label>
          <label className="is-span-2">
            활동 목적
            <textarea rows={2} readOnly value={detail.purpose || ''} />
          </label>
          <label className="is-span-2">
            활동 목표
            <textarea rows={2} readOnly value={detail.activityGoal || ''} />
          </label>
          <label>
            리더
            <input readOnly value={detail.leaderName || '-'} />
          </label>
          <label>
            간사
            <input readOnly value={detail.secretaryName || '-'} />
          </label>
          <label className="is-span-2">
            구성원
            <textarea rows={2} readOnly value={detail.members || '-'} />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={2} readOnly value={detail.remark || ''} />
          </label>
        </div>
      </section>
    </div>
  );
}

export default SmallGroupPreviewView;
